import type { BadgeSize } from './Badge'

export const BADGE_SIZE_STYLES: Record<
  BadgeSize,
  { fontSize: number; padding: string; minHeight: number }
> = {
  sm: { fontSize: 10, padding: '3px 10px', minHeight: 22 },
  md: { fontSize: 11, padding: '5px 12px', minHeight: 24 },
  lg: { fontSize: 12, padding: '6px 14px', minHeight: 26 },
}
